import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { tmdbAPI } from '../services/api';
import MediaCard from '../components/MediaCard';
import { HiOutlineSearch, HiOutlineFilm, HiOutlineX } from 'react-icons/hi';

function Search() {
  const { t } = useTranslation();
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searched, setSearched] = useState(false);

  const handleSearch = useCallback(async () => {
    if (!query.trim()) {
      setResults([]);
      setSearched(false);
      return;
    }

    setLoading(true);
    setSearched(true);
    try {
      const response = await tmdbAPI.search(query);
      setResults(response.data.results || []);
    } catch (error) {
      console.error('Error searching:', error);
      setResults([]);
    } finally {
      setLoading(false);
    }
  }, [query]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      handleSearch();
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [query, handleSearch]);

  return (
    <div>
      <div className="page-header">
        <h1>{t('search.title')}</h1>
        <p>{t('search.subtitle')}</p>
      </div>

      <div className="search-container">
        <HiOutlineSearch className="search-icon" />
        <input
          type="text"
          className="search-input"
          placeholder={t('search.placeholder')}
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
        {query.length > 0 && (
          <button
            className="search-clear-btn"
            onClick={() => {
              setQuery('');
              setResults([]);
              setSearched(false);
            }}
            aria-label="Clear search"
          >
            <HiOutlineX size={18} />
          </button>
        )}
      </div>

      {!searched && !loading && (
        <div className="card">
          <div className="card-content-scrollable">
            <div className="empty-state">
              <div className="empty-state-icon">
                <HiOutlineSearch size={48} />
              </div>
              <h3>{t('search.searchToFind', 'Busque filmes e séries')}</h3>
              <p>{t('search.searchHint', 'Digite o nome de um filme ou série para encontrar')}</p>
            </div>
          </div>
        </div>
      )}

      {loading ? (
        <div className="card">
          <div className="card-content-scrollable">
            <div className="loading-container">
              <div className="spinner"></div>
            </div>
          </div>
        </div>
      ) : searched ? (
        <div className="card">
          <div className="card-header">
            <h2>{`${t('search.resultsFor')} "${query}"`}</h2>
          </div>
          <div className="card-content-scrollable">
            {results.length > 0 ? (
              <div className="cards-grid">
                {results.map((item) => (
                  <MediaCard
                    key={`${item.media_type || item.id}-${item.id}`}
                    item={item}
                  />
                ))}
              </div>
            ) : (
              <div className="empty-state">
                <div className="empty-state-icon">
                  <HiOutlineFilm size={32} />
                </div>
                <h3>{t('search.noResults')}</h3>
                <p>{t('search.tryDifferentTerm')}</p>
              </div>
            )}
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default Search;
